/*
  COSMIC 9 GEMS — WEIGHT CONVERTER

  Three linked fields: carat, ratti, gram. Type in any one and the other two
  follow. Progressive enhancement over a page that already renders a readable
  reference table without it.

  The carat is exact (1 ct = 0.2 g, by definition). The ratti is not — the
  carats-per-ratti figure is a merchant setting and arrives on the element as
  a data attribute, so this file never asserts a conversion of its own.
*/

(() => {
  'use strict';

  const GRAMS_PER_CARAT = 0.2;

  /* Trim to a sensible number of places without dragging in a formatter:
     gemstone weights are quoted to 2-3 decimals, and trailing zeros read as
     false precision on a page about weights. */
  const tidy = (n, places) => {
    if (!isFinite(n)) return '';
    return parseFloat(n.toFixed(places)).toString();
  };

  class Converter {
    constructor(root) {
      this.root = root;
      this.ctPerRatti = parseFloat(root.dataset.caratsPerRatti);
      if (!(this.ctPerRatti > 0)) this.ctPerRatti = 0.91;

      this.inputs = {};
      root.querySelectorAll('[data-unit]').forEach((el) => {
        this.inputs[el.dataset.unit] = el;
        el.addEventListener('input', () => this.from(el.dataset.unit));
      });

      this.result = root.querySelector('[data-c9-converter-result]');

      const reset = root.querySelector('[data-c9-converter-reset]');
      if (reset) {
        reset.addEventListener('click', () => {
          this.inputs.carat.value = '1';
          this.from('carat');
          this.inputs.carat.focus();
        });
      }

      /* Seed the other two from whatever the markup shipped with. */
      this.from('carat');
    }

    from(unit) {
      const raw = parseFloat(this.inputs[unit].value);

      if (!isFinite(raw) || raw < 0) {
        Object.keys(this.inputs).forEach((k) => {
          if (k !== unit) this.inputs[k].value = '';
        });
        if (this.result) this.result.textContent = '';
        return;
      }

      let carat;
      if (unit === 'carat') carat = raw;
      else if (unit === 'ratti') carat = raw * this.ctPerRatti;
      else carat = raw / GRAMS_PER_CARAT;

      const ratti = carat / this.ctPerRatti;
      const gram = carat * GRAMS_PER_CARAT;

      if (unit !== 'carat') this.inputs.carat.value = tidy(carat, 3);
      if (unit !== 'ratti') this.inputs.ratti.value = tidy(ratti, 3);
      if (unit !== 'gram') this.inputs.gram.value = tidy(gram, 4);

      if (this.result) {
        this.result.textContent =
          `${tidy(carat, 3)} carat = ${tidy(ratti, 3)} ratti = ${tidy(gram, 4)} gram`;
      }
    }
  }

  const init = () => {
    document.querySelectorAll('[data-c9-converter]').forEach((root) => {
      if (root.dataset.c9ConverterReady === 'true') return;
      root.dataset.c9ConverterReady = 'true';
      new Converter(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
